module.exports = __webpack_public_path__ + "static/can_logo_colour-beb90c24007afaeae06b3808bf240ebe.png";